module.exports = __webpack_public_path__ + "img/booth-aipiano.8c3963a5.jpg";